import { SortAscendingOutlined } from "@ant-design/icons";
import { Dropdown, MenuProps, Space } from "antd";


import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { handleSetInvoiceFilter } from "../ClientSideStates";

const Sorting = () => {
  const dispatch = useDispatch();
const {filter} = useSelector((state:RootState)=>state.invoice)
  const applySorterFilter = ({ key }: { key: string }) => {
    let newFilter: any = {};

    const parsedKey = key.split("_");
    if (!!parsedKey[1]) {
      newFilter.SortProperty = parsedKey[0];
      newFilter.SortType = parsedKey[1] === "asc" ? "asc" : "desc";
      let allFilter = { ...filter, ...newFilter };

      dispatch(
        handleSetInvoiceFilter({ filter: allFilter })
      );
    }
  };

  const sortingDropdownMenu: MenuProps["items"] = [
    {
      key: "InsertDate_asc",
      label: "İstenilen tarihi en eskiden en yeniye sırala",
    },
    {
      key: "InsertDate_desc",
      label: "İstenilen tarihi en yeniden en eskiye sırala",
    },
    {
      key: "Amount_asc",
      label: "Fatura tutarını en düşükten en yükseğe sırala",
    },
    {
      key: "Amount_desc",
      label: "Fatura tutarını en yüksekten en düşüğe sırala",
    },
  ];
  

    
   

  return (
    <>
      <Dropdown
        menu={{
          items: sortingDropdownMenu,
          onClick: applySorterFilter,
        }}
        className="!mr-4"
      >
        <span onClick={(e) => e.preventDefault()}>
          <Space>
            <SortAscendingOutlined />
          </Space>
        </span>
      </Dropdown>
    </>
  );
};

export default Sorting;
